import { createRouter, createWebHistory } from "vue-router";
import navigationGuard from "@/utils/Authentication/implicitOnNavigationGuard";
import { auth } from "@/utils/LtkAuth0";

const routes: any = [
  {
    path: "/",
    component: () => import("../App.vue"),
  },
  {
    path: "/login",
    name: "Login",
    beforeEnter: async () => {
      return auth.login();
    },
    meta: { requiresAuth: false },
  },
  {
    name: "loginCallback",
    path: "/login/callback",
    beforeEnter: async () => {
      await auth.handleRedirectCallback();
    },
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/error",
    name: "Error",
    component: () =>
      import(/* webpackChunkName: "error" */ "@/views/LtkError.vue"),
  },
  {
    path: "/logged-in",
    name: "LoggedIn",
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "loggedIn" */ "@/views/LoggedIn.vue"),
  },
  {
    path: "/welcome",
    name: "Welcome",
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "loggedIn" */ "@/views/Welcome.vue"),
  },
  {
    path: "/kick-off",
    component: () => import("@/views/KickOff/KickOffView.vue"),
    meta: {
      title: "LTK品牌入驻",
      requiresAuth: false,
    },
    children: [
      {
        name: "KickOffForm",
        path: "form",
        meta: {
          title: "LTK品牌入驻",
          requiresAuth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "kick-off-form" */ "@/views/KickOff/KickOffForm.vue"
          ),
      },
      {
        name: "SubmitResult",
        path: "result",
        meta: {
          title: "LTK品牌入驻",
          requiresAuth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "kick-off-form" */ "@/views/KickOff/SubmitResult.vue"
          ),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

router.beforeEach(navigationGuard);

export default router;
